import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseApiWithAuth } from "@/utilities/reduxToolkit";

export interface NewsfeedItem {
  id: string;
  title: string;
  description: string;
  url: string;
  imageUrl?: string;
  source: string;
  publishedAt: string;
}

export interface NewsfeedResponse {
  data: NewsfeedItem[];
  market: string;
  source: string;
  fetchedAt: string;
}

export interface NewsfeedQueryParams {
  market?: string;
  limit?: number;
}

export const newsfeedApi = createApi({
  ...createBaseApiWithAuth({
    reducerPath: "newsfeedApi",
    baseUrl: "/api/newsfeed",
  }),
  reducerPath: "newsfeedApi",
  tagTypes: ["Newsfeed"],
  endpoints: (builder) => ({
    getNewsfeed: builder.query<NewsfeedResponse, NewsfeedQueryParams | void>({
      query: (params) => ({
        url: "",
        params: params || {},
      }),
      providesTags: ["Newsfeed"],
    }),
  }),
});

export const { useGetNewsfeedQuery } = newsfeedApi;
